import PlaceholderPage from './PlaceholderPage';

/** Gift Shop print-frame-selection screen (scaffold). */
function PrintFrameSelection() {
  return <PlaceholderPage title="Print Frame Selection" />;
}

export default PrintFrameSelection;
